const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export {
    emailRegExp
}